export default function isWithinOneMonth(date1, date2) {
	const timeDifference = Math.abs(date2 - date1);
	const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
	return daysDifference <= 30; // Assuming a month has 30 days
}